module.exports = __webpack_public_path__ + "media/née bpen gaan sŏn tam-má ná pôo jà-rern.90e810bb.mp3";